// frontend/src/utils/tenant.js

/**
 * Verifica si un hostname es una dirección IP
 */
function isIpAddress(hostname) {
  // Regex para IPv4 (ej: 192.168.1.2)
  const ipv4Pattern = /^(\d{1,3}\.){3}\d{1,3}$/;
  return ipv4Pattern.test(hostname);
}

/**
 * Detecta el tenant ID desde el subdominio o localStorage
 */
export function detectTenantFromSubdomain() {
  const hostname = window.location.hostname;
  
  
  // Desarrollo local (localhost, 127.0.0.1 o IPs privadas)
  if (hostname === 'localhost' || hostname === '127.0.0.1' || isIpAddress(hostname)) {
    const devTenant = localStorage.getItem('dev_tenant_id') || process.env.REACT_APP_TENANT_ID || 'demo'; 
    return devTenant;
  }
  
  // Producción: detectar por subdominio (ej: power.tugimnasio.com)
  const parts = hostname.split('.');
  
  // Necesita al menos 3 partes para ser un subdominio válido
  if (parts.length >= 3) {
    const subdominio = parts[0];
    
    // Mapear subdominios a tenant_ids
    const subdomainMap = {
      'powertraining': 'power_training',
      'demo': 'demo',

    };
    
    const tenantId = subdomainMap[subdominio] || subdominio;
    return tenantId;
  }
  
  // Fallback: gimnasio_power
  return 'demo';
}

/**
 * Obtiene el tenant ID almacenado (desarrollo)
 */
export function getStoredTenantId() {
  return localStorage.getItem('dev_tenant_id') || null;
}

/**
 * Guarda el tenant ID manualmente (desarrollo)
 */
export function setStoredTenantId(tenantId) {
  localStorage.setItem('dev_tenant_id', tenantId);
}

/**
 * Obtiene la configuración del tenant desde el backend
 */
export async function fetchTenantConfig(apiUrl, tenantId = null) {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (tenantId) {
      headers['X-Tenant-ID'] = tenantId;
    }
    
    
    const response = await fetch(`${apiUrl}/tenant/config/`, { headers });
    
    if (!response.ok) {
      console.error('❌ Error fetching tenant config:', response.status);
      return null;
    }
    
    const config = await response.json();
    return config;
    
  } catch (error) {
    console.error('❌ Error loading tenant config:', error);
    return null;
  }
}
